<template>
  <div>
    <a-alert type="error">
      <h3 slot="message">Warning 🔥 {{tenant.name}}</h3>
      <div slot="description">
        <p
          class="lead"
          v-if="!tenant.delete_protection"
        >Deleting a tenant is an irreversible action. Once deleted, all tenant data will be erased from our backends and it can not be recovered.</p>
        <p
          class="lead"
          v-else
        >Delete protection is on for this tenant. Please contact the Axioms support team if you would like disable this switch and delete this tenant.</p>
        <a-popconfirm
          okText="Yes"
          v-if="!tenant.delete_protection"
          cancelText="No"
          style="margin-top: 8px;"
          @confirm="handleDelete"
        >
          <p
            slot="title"
            style="font-size:14px;"
          >Do you want to delete this tenant ({{tenant.name}})？ <br> Once deleted you will loose your primary domain slug.</p>
          <a-icon slot="icon" type="question-circle-o" style="color: red" />
          <a-button type="danger" size="large" :disabled="tenant.delete_protection">Delete tenant</a-button>
        </a-popconfirm>
        <a-button
          type="danger"
          v-else
          size="large"
          :disabled="tenant.delete_protection"
        >Delete tenant</a-button>
      </div>
    </a-alert>
  </div>
</template>

<script>
export default {
  computed: {
    tenant() {
      return this.$store.state.core.tenants_item;
    }
  },
  methods: {
    async handleDelete() {
      try {
        if (this.tenant.uuid !== this.$auth.session.org) {
          throw new TypeError("Tenant UUID and sessions org UUID don't match");
        }
        if (this.tenant.delete_protection || this.tenant.is_internal) {
          throw new TypeError(
            "Tenant has delete protection, please contact support."
          );
        }
        await this.$store.dispatch("core/deleteItem", {
          endpoint: "tenants",
          uuid: this.$auth.session.org
        });
        this.$auth.session.org = false;
        await this.$router.replace("/");
        await this.$store.dispatch("ui/changeUIKey");
        await this.$notification.open({
          message: "Tenant deleted!",
          description: "Tenant was deleted.",
          icon: (
            <a-icon type="check-circle" theme="filled" style="color: green" />
          )
        });
      } catch (error) {
        console.error(error);
        this.$notification.open({
          message: "Action failed!",
          description: "Tenant deletion failed.",
          icon: <a-icon type="close-circle" theme="filled" style="color: red" />
        });
      }
    }
  }
};
</script>
